import { useEffect } from "react";
import { controlApi } from "./controlApi";

const SEEN_KEY = "spc_budget_alerts_seen";

// Local notification for AI-budget alerts (80% / 100%) when the user enabled
// notifications on this device. Works while the PWA is open or in background.
export function useBudgetAlertNotifier(user) {
  useEffect(() => {
    if (!user || !("Notification" in window)) return undefined;
    let alive = true;
    const tick = async () => {
      if (Notification.permission !== "granted") return;
      try {
        const r = await controlApi.incidents({ component: "ai_budget", limit: 20 });
        if (!alive) return;
        const seen = new Set(JSON.parse(localStorage.getItem(SEEN_KEY) || "[]"));
        const open = (r.items || []).filter((i) => i.status !== "resolved");
        const swReg = navigator.serviceWorker ? await navigator.serviceWorker.getRegistration() : null;
        for (const i of open) {
          const key = `${i.id}:${i.severity}`;
          if (seen.has(key)) continue;
          seen.add(key);
          const opts = { body: i.description, tag: `ai-budget-${i.code}`, data: { url: "/control/alerts" } };
          if (swReg && swReg.showNotification) await swReg.showNotification(i.title, opts);
          else new Notification(i.title, opts); // eslint-disable-line no-new
        }
        localStorage.setItem(SEEN_KEY, JSON.stringify([...seen].slice(-50)));
      } catch { /* offline / permission revoked */ }
    };
    tick();
    const t = setInterval(tick, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [user]);
}
